import {RECEIVE_PROFILE} from '../../constants';

const initialState = {
  loginCount: 0
}

export default function profile(state = initialState, action) {
  switch (action.type) {
    case RECEIVE_PROFILE:
      return {
        ...state,
        ...action.profile
      }
    default:
      return state;
  }
}


/** WEBPACK FOOTER **
 ** ./src/store/reducers/profile.js
 **/